export const environment = {
    appInsights: {
      instrumentationKey: '#{insightsInstrumentationKey}#',
    },
    production: true,
    endpoints: {
      baseUrl: '#{baseUrl}#',
      apiUrl: '#{apiUrl}#',
      websocketUrl: '#{wsUrl}#',
    },
    name: 'TXdocs Editor',
  };
  